import { render, staticRenderFns } from "./page-reward.vue?vue&type=template&id=0081abe0"
import script from "./page-reward.vue?vue&type=script&lang=ts"
export * from "./page-reward.vue?vue&type=script&lang=ts"
import style0 from "./page-reward.vue?vue&type=style&index=0&id=0081abe0&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports